import React from 'react'
import { Tab } from 'semantic-ui-react'
import RegisterBP from './RegisterBP';
import RegisterSTS from './RegisterSTS';
import SPJPendapatan from './SPJPendapatan';
import BPHarian from './BPHarian';

const panes = [
   { 
      menuItem: 'REGISTER BP', 
      render: () => <Tab.Pane attached={false}><RegisterBP /></Tab.Pane> 
   },
   // { 
   //    menuItem: 'REGISTER STS', 
   //    render: () => <Tab.Pane attached={false}><RegisterSTS /></Tab.Pane> 
   // },
   { 
      menuItem: 'SPJ PENDAPATAN ADMINISTRATIF', 
      render: () => <Tab.Pane attached={false}><SPJPendapatan /></Tab.Pane> 
   },
   { 
      menuItem: 'REKAPITULASI PENERIMAAN HARIAN', 
      render: () => <Tab.Pane attached={false}><BPHarian /></Tab.Pane> 
   }
]

const ReportIndex = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default ReportIndex;


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_report/ReportIndex.js